import { isEqual } from 'lodash-es';

import { useStoreSelector } from '../../../core/store/selector.js';
import { HoneycombStoreContext } from '../context/honeycomb-store.context.js';
import { HoneycombState } from '../types/state.js';

export const useSelector = <T>(selector: (state: HoneycombState) => T): T =>
  useStoreSelector(HoneycombStoreContext, selector, isEqual);

export const useHoneycombSelectionState = () =>
  useSelector((state: HoneycombState) => state.selection);

export const useHoneycombToolbarVisibleState = () =>
  useSelector((state: HoneycombState) => state.overlay.toolbarVisible);
